<template>
  <main class="profile_main">
    <section v-if="isViewingMode" :class="['top_banner', bannerClassByUserLevel]">
      <div
        v-if="isViewingMode"
        class="edit_prof"
        @click.prevent="toEdit()"
        style="cursor: pointer"
      >
        <img src="/static/images/edit_prof_icon.png" />
        <p> {{ getTranslations.home_profile_edit }} </p>
      </div>
      <div v-if="isViewingMode" class="avatar-container">
        <base-avatar-image :src="userDetails.avatar" image-class="prof_avatar"></base-avatar-image>
      </div>
    </section>

    <profile-stats v-if="isViewingMode"></profile-stats>

    <default-content-profile v-if="isViewingMode"></default-content-profile>
    <!--TO-DO FRIEND INVITE-->
    <!--    <section id="home_invite">-->
    <!--      <div class="box flex-row">-->
    <!--        <div class="flex-column col1">-->
    <!--          <img src="/static/images/home/invite.png">-->
    <!--        </div>-->
    <!--        <div class="flex-column col2">-->
    <!--          <p class="heading">Invite Friends</p>-->
    <!--          <p class="text">Invite Your Friends, Earn Points, and Redeem Exciting Rewards!</p>-->
    <!--        </div>-->
    <!--        <div class="flex-column col3">-->
    <!--          <i class="fas fa-chevron-right"></i>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </section>-->


    <ProfileEdit v-if="!isViewingMode"></ProfileEdit>

  </main>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseAvatarImage from '../../common/image/BaseAvatarImage'
import FacebookLogin from '@/components/visitor/FacebookLogin';
import ProfileStats from './ProfileStats';
import EditAvatar from './EditAvatar';
import DefaultContentProfile from './DefaultContentProfile';
import ProfilePerformance from './ProfilePerformance';
import AchievementsProfile from './AchievementsProfile';
import ProfileEdit  from "./ProfileEdit";

export default {
  name: 'profile',
  data() {
    return {
      fbActionType: 'ConnectProf',
      errorInFb: false,
    };
  },
  created() {
  },
  components: {
    BaseAvatarImage,
    AchievementsProfile,
    ProfilePerformance,
    DefaultContentProfile,
    ProfileStats,
    EditAvatar,
    FacebookLogin,
    ProfileEdit,
  },
  methods: {
    ...mapActions('profile', [
      'storePerformance',
    ]),
    getFbMessage() {
      return this.getTranslations.visitor_sign_up_3_fb_username_first;
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    isEditMode() {
      return this.$route.path === '/home/profile/edit';
    },
    hasFb() {
      return this.$route.path === '/home/profile'
        && !this.userDetails.facebookId
        && this.facebookFunctionality;
    },
  },
  computed: {
    getDisplayUsername() {
      return this.userDetails.username;
    },
    isViewingMode() {
      return !this.isEditMode();
    },
    bannerClassByUserLevel () {
      return `lvl${Math.min(this.userDetails.level, 4)}`
    },
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'connectionPoints',
      'facebookFunctionality',
    ]),
    ...mapState('profile', [
      'performanceInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Profile.vue